import {
  Box,
  Input,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

const InputInline = ({
  label,
  control,
  keyName,
  endAdm,
  propsInput,
  inline,
  children,
}) => {
  const { register } = control;

  return (
    <Box display={inline ? "flex" : ""}>
      <Typography variant="body1" component="span">
        {label}
      </Typography>
      {children ?? (
        <Input
          {...register(keyName)}
          className="input-form-response"
          sx={{ outline: "none", color: "#0032ff" }}
          endAdornment={
            <InputAdornment position="end">{endAdm}</InputAdornment>
          }
          {...propsInput}
        />
      )}
    </Box>
  );
};

export default InputInline;
